import { Checkbox, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { prepareCustomerResultsResultTypeOptions } from 'interfaces/job';
import { every, includes, isEmpty, join, map, size } from 'lodash';
import React from 'react';

export const FilesToExportSelect = ({
  selectedFilesToExport,
  onChange,
}: {
  selectedFilesToExport: string[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
}) => {
  const areAllSelected =
    selectedFilesToExport &&
    // Check all selected file values equal to all available file values
    size(selectedFilesToExport) === size(prepareCustomerResultsResultTypeOptions) &&
    every(prepareCustomerResultsResultTypeOptions, (option) => includes(selectedFilesToExport, option));
  const areSomeSelected = !isEmpty(selectedFilesToExport) && size(selectedFilesToExport) > 0 && !areAllSelected;

  return (
    <>
      <InputLabel>Files to export</InputLabel>
      <Select
        multiple
        value={selectedFilesToExport}
        onChange={(event) => {
          if (includes(event.target.value, 'ALL')) {
            onChange({
              target: { value: areAllSelected ? [] : prepareCustomerResultsResultTypeOptions },
            } as SelectChangeEvent<string[]>);
            return;
          }
          onChange(event);
        }}
        renderValue={(selected) => join(selected, ', ')}
      >
        <MenuItem value="ALL">
          <Checkbox checked={areAllSelected} indeterminate={areSomeSelected} />
          <ListItemText primary={'All'} />
        </MenuItem>
        {map(prepareCustomerResultsResultTypeOptions, (option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={includes(selectedFilesToExport, option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
